import { AttachmentCategory, SocialAttachment } from './attachment';

interface GifAPIData {
	content_description: string;
	media: {
		gif: { url: string };
		mp4: { url: string };
		tinygif: { url: string };
	}[];
}

export class Gif {
	constructor(
		public id: string,
		public data: GifAPIData
	) {}

	get content_description() {
		return this.data.content_description;
	}

	get gif() {
		return this.data.media[0].gif.url;
	}

	get mp4() {
		return this.data.media[0].mp4.url;
	}

	get preview() {
		return this.data.media[0].tinygif.url;
	}

	toAttachment() {
		return new SocialAttachment({
			category: AttachmentCategory.Social,
			alt_text: this.content_description,
			gif: this.gif,
			mp4: this.mp4,
		});
	}
}
